(function () {
  if (!('serviceWorker' in navigator)) return;

  // ↑ bumpuj pri svakom release-u
  var SW_VERSION = '1.2.21';

  // BASE_URL -> uzmi samo path (radi i za apsolutni URL)
  var base = (typeof BASE_URL === 'string' && BASE_URL) ? BASE_URL : '/';
  var basePath;
  try { basePath = new URL(base, location.origin).pathname; }
  catch (e) { basePath = base; }

  // Registrujemo isključivo na /lucky-balls/
  var scopePath = (basePath.replace(/\/$/, '') + '/lucky-balls/').replace(/\/{2,}/g, '/');
  var swUrl     = scopePath + 'sw.js?v=' + encodeURIComponent(SW_VERSION);

  // Ako nismo na odgovarajućem path-u, preskačemo
  if (!location.pathname.startsWith(scopePath)) {
    console.log('[SW-REGISTER] skipped', { pathname: location.pathname, scopePath: scopePath });
    return;
  }

  console.log('[SW-REGISTER] bootstrap', { scopePath: scopePath, swUrl: swUrl, v: SW_VERSION });

  // 0) Uvek povuci SVEŽ sw.js pre registracije (zaobiđi agresivni cache/ekstenzije)
  try { fetch(swUrl, { cache: 'reload' }); } catch (e) {}

  // ---- 1) Ukloni starije/legacy workere na istom scope-u
  var removedAny = false;
  function nukeOld() {
    return navigator.serviceWorker.getRegistrations().then(function (regs) {
      return Promise.all(regs.map(function (r) {
        var scriptURL = (r.active && r.active.scriptURL)
                     || (r.waiting && r.waiting.scriptURL)
                     || (r.installing && r.installing.scriptURL)
                     || '';
        var inThisScope = (r.scope && r.scope.replace(location.origin, '').endsWith('/lucky-balls/'));
        var isNew       = /\/lucky-balls\/sw\.js(\?|$)/.test(scriptURL);
        var isLegacy    = /luckyballs\.cache(\.ios)?\.js/i.test(scriptURL);

        // ukloni sve legacy + sve što NIJE naš novi sw.js ali je na istom scope-u
        if (inThisScope && (isLegacy || !isNew)) {
          console.log('[SW-REGISTER] unregister', { scriptURL: scriptURL, scope: r.scope });
          removedAny = true;
          return r.unregister().catch(function(){});
        }
      }));
    });
  }

  // ---- 2) Ako smo nešto obrisali i postoji stari controller, reload da ga pustimo
  function maybeReloadThenRegister() {
    if (removedAny && navigator.serviceWorker.controller) {
      console.log('[SW-REGISTER] reloading to drop old controller…');
      location.reload();               // posle reloada skripta se opet pokreće i ići će na registerNew()
      return Promise.reject('reloading');
    }
    return Promise.resolve();
  }

  // ---- 3) Registruj novi SW + health-check
  function registerNew() {
    return navigator.serviceWorker.register(swUrl, { scope: scopePath, updateViaCache: 'none' })
      .then(function (reg) {
        console.log('[SW-REGISTER] registered', swUrl);

        try { reg.update(); } catch (e) {}

        if (reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });

        reg.addEventListener('updatefound', function () {
          var sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', function () {
            if (sw.state === 'installed') {
              var ts = new Date().toISOString();
              if (navigator.serviceWorker.controller) {
                console.log('[SW] updated v' + SW_VERSION + ' at ' + ts);
                if (reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
              } else {
                console.log('[SW] installed v' + SW_VERSION + ' at ' + ts);
              }
            }
          });
        });

        if (reg.active) console.log('[SW] Active scriptURL:', reg.active.scriptURL);

        // HEALTH-CHECK: pingni SW za verziju; ako ne odgovori / pogrešna → self-heal
        return healthCheck().catch(function () {
          console.warn('[SW] health-check failed; attempting self-heal…');
          return selfHeal(scopePath, swUrl);
        });
      })
      .catch(function (err) {
        if (err !== 'reloading') console.warn('[SW] registration failed:', err);
      });
  }

  // ---- 4) Jednokratni reload kada novi SW preuzme kontrolu
  var reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', function () {
    if (reloaded) return;
    reloaded = true;
    if (document.visibilityState === 'visible') {
      location.reload();
    } else {
      var onVisible = function () {
        document.removeEventListener('visibilitychange', onVisible);
        location.reload();
      };
      document.addEventListener('visibilitychange', onVisible);
    }
  });

  // ---- 5) Sekvenca
  nukeOld()
    .then(maybeReloadThenRegister)
    .then(registerNew);

  // ---- helpers ----

  // SW šalje {type:'SW_VERSION', version: ...} (vidi sw-extras.js ispod)
  function healthCheck() {
    return new Promise(function (resolve, reject) {
      if (!navigator.serviceWorker.controller) {
        // daj malo vremena da controller legne
        setTimeout(resolve, 400);
        return;
      }
      var channel = new MessageChannel();
      var timer = setTimeout(function () {
        channel.port1.onmessage = null;
        reject(new Error('timeout'));
      }, 1500);

      channel.port1.onmessage = function (e) {
        clearTimeout(timer);
        try {
          var data = e.data || {};
          if (data.type === 'SW_VERSION' && String(data.version) === String(SW_VERSION)) {
            resolve();
          } else {
            reject(new Error('version-mismatch'));
          }
        } catch (err) {
          reject(err);
        }
      };

      try {
        navigator.serviceWorker.controller.postMessage({ type: 'PING_VERSION' }, [channel.port2]);
      } catch (e) {
        clearTimeout(timer);
        reject(e);
      }
    });
  }

  function selfHeal(scopePath, swUrl) {
    return navigator.serviceWorker.getRegistrations().then(function (regs) {
      return Promise.all(regs.map(function (r) {
        var scriptURL = (r.active && r.active.scriptURL)
          || (r.waiting && r.waiting.scriptURL)
          || (r.installing && r.installing.scriptURL) || '';
        var inScope = (r.scope && r.scope.replace(location.origin, '').endsWith('/lucky-balls/'));
        var isOurs = /\/lucky-balls\/sw\.js(\?|$)/.test(scriptURL);
        if (inScope && !isOurs) {
          return r.unregister().catch(function(){});
        }
      }));
    }).then(function () {
      if ('caches' in window) {
        return caches.keys().then(function (names) {
          return Promise.all(names.map(function (n) {
            if (/^lucky-balls-/.test(n) || /-pages-v[12]$/.test(n) || /-static-v[12]$/.test(n)) {
              return caches.delete(n);
            }
          }));
        }).catch(function(){});
      }
    }).then(function () {
      // povuci svež sw.js i uradi soft-reload sa cache-busterom
      return fetch(swUrl, { cache: 'reload' }).finally(function () {
        var u = new URL(location.href);
        u.searchParams.set('r', Date.now());
        location.replace(u.toString());
      });
    });
  }

  // (opciono) log poruke koje šalje SW
  navigator.serviceWorker.addEventListener('message', function (event) {
    if (event.data && event.data.type === 'SW_VERSION') {
      console.log('[SW] running version:', event.data.version);
    }
  });
})();



//////////////////
// WEBPACK FOOTER
// ./src/sw-register.js
// module id = 2457
// module chunks = 12